<template>
  <div class="personal_calendar_wrapper md:!tw-mt-4">
    <v-btn
      class="button button-orange desktop_wrapper !tw-bg-[#3366FF]"
      @click="onClickCreateEventModal"
    >
      Add Event
    </v-btn>
    <!-- <Button
      variant="accent"
      label="Add Event"
      class="!tw-w-auto tw-hidden rmd:!tw-inline"
      @click="onClickCreateEventModal"
    /> -->
    <div class="personal_calendar_header">
      <div class="date_selector">
        {{ selectedDate }}
      </div>
      <div class="personal_calendar_tabs">
        <v-btn
          class="button"
          :class="selectedView == 'day' ? 'button-active' : ''"
          variant="plain"
          @click="handleCalenderView('day')"
        >
          Day
        </v-btn>
        <v-btn
          class="button"
          :class="selectedView == 'week' ? 'button-active' : ''"
          variant="plain"
          @click="handleCalenderView('week')"
        >
          Week
        </v-btn>
        <v-btn
          class="button"
          :class="selectedView == 'month-grid' ? 'button-active' : ''"
          variant="plain"
          @click="handleCalenderView('month-grid')"
        >
          Month
        </v-btn>
      </div>
    </div>
    <v-btn
      class="button button-orange mobile_wrapper"
      :style="{ backgroundColor: '#3366FF' }"
      @click="createEventModal = true"
    >
      Add Event
    </v-btn>
    <!-- <Button
      variant="accent"
      label="Add Event"
      class="!tw-w-auto tw-inline rmd:!tw-hidden"
      @click="createEventModal = true"
    /> -->
    <ScheduleXCalendar
      :calendar-app="calendarApp"
      event-modal="modal"
      class="personal_calendar"
      :class="`personal_calendar_grid_line_${selectedView}`"
    >
      <template #eventModal="{ calendarEvent }">
        <div class="calendar_event_modal shadow">
          <h6>{{ calendarEvent?.title }}</h6>
          <p v-if="selectedView == 'month-grid'">
            {{ formatDateRange(calendarEvent?.start, calendarEvent?.end) }}
          </p>
          <p v-else>{{ formatDate(calendarEvent?.start, "fullDayDate") }}</p>

          <div v-if="selectedView == 'week'" class="calendar_time">
            <span>{{ calendarEvent?.start?.split(" ")[1] }}</span> to
            <span>{{ calendarEvent?.end?.split(" ")[1] }}</span>
          </div>
          <div
            v-else-if="selectedView == 'month-grid'"
            class="calendar_time"
          ></div>

          <div v-else class="calendar_time">
            <span>({{ calendarEvent?.start?.split(" ")[1] }} am</span> to
            <span>{{ calendarEvent?.end?.split(" ")[1] }} am)</span>
          </div>
          <div class="calendar_event_modal_footer">
            <div class="calendar_edit_wrapper">
              <v-icon
                @click="fetchModalData(calendarEvent.id)"
                class="edit_modal"
              >
                <img
                  src="../../../assets/icons/calendar-modal-edit.svg"
                  alt=""
                />
              </v-icon>
              <v-icon
                @click="deleteEvent(calendarEvent.id)"
                class="delete_modal"
              >
                <img
                  src="../../../assets/icons/calendar-delete-modal.svg"
                  alt=""
                />
              </v-icon>
            </div>
          </div>
        </div>
      </template>
    </ScheduleXCalendar>
    <!-- update Event Modal -->
    <CommonDialog
      v-model="openEditModal"
      :isShowHeader="false"
      :isShowBackButton="false"
      :className="['update_event_modal']"
      width="441px"
      height="auto"
      ><template v-slot:body>
        <div class="modal_content">
          <div class="header">
            <h4>Edit Event</h4>
            <v-btn
              variant="plain"
              icon="mdi-close"
              @click="openEditModal = false"
            ></v-btn>
          </div>
          <div class="modal_form">
            <div class="form_wrapper">
              <div class="list_block__item">
                <div class="event_field">
                  <label>Event Name</label>
                  <v-text-field
                    class="input_field"
                    placeholder="Enter event name"
                    v-model="getCalenderEventById.name"
                    :rules="[
                      (v) => !!v || 'Name is required',
                      (v) => v.length <= 255 || 'Name is too long',
                    ]"
                    variant="outlined"
                  ></v-text-field>
                </div>
                <div class="event_field">
                  <label>Location</label>
                  <v-text-field
                    class="input_field"
                    placeholder="Enter location"
                    v-model="getCalenderEventById.location"
                    :rules="[(v) => v.length <= 50 || 'Location is too long']"
                    variant="outlined"
                  ></v-text-field>
                </div>
                <div class="date_time_selector">
                  <div class="event_field date_selector">
                    <label>Date</label>
                    <DatePicker
                      :min-date="new Date()"
                      v-model="getCalenderEventById.startDate"
                      :popover="true"
                    >
                      <template #default="{ togglePopover, inputValue }">
                        <div
                          class="calendar__select"
                          @click="() => togglePopover()"
                        >
                          <v-text-field
                            :value="inputValue"
                            variant="outlined"
                            placeholder="Choose Date"
                            class="date__start input_field"
                            color="#0C0F4A"
                          >
                            <img
                              src="../../../assets/icons/personal-calendar.svg"
                              alt=""
                            />
                          </v-text-field>
                        </div>
                      </template>
                    </DatePicker>
                  </div>

                  <!-- From Custom Dropdown -->
                  <div class="event_field time_selector">
                    <label>Choose time</label>
                    <div class="time_wrapper">
                      <div class="time_dropdown">
                        <v-text-field
                          density="compact"
                          placeholder="HH:MM"
                          variant="outlined"
                          v-model="getCalenderEventById.startTime"
                          class="input_field"
                          @click="fromToggleDropdown"
                          :class="{ 'is-open': fromDropdownOpen }"
                        >
                          <v-icon
                            icon="mdi-clock"
                            id="menu-activator"
                            class="cursor-pointer"
                          ></v-icon>
                        </v-text-field>
                        <div
                          v-if="startTimeError"
                          class="text-red error-message tw-text-xs"
                        >
                          {{ startTimeError }}
                        </div>
                        <ul
                          class="custom_dropdown__menu"
                          v-if="fromDropdownOpen"
                        >
                          <li
                            class="custom_dropdown__item"
                            v-for="(time, index) in filteredFromTimes"
                            :key="index"
                            @click="toggleDropdownOutside"
                          >
                            <label
                              @click="getCalenderEventById.startTime = time"
                              for=""
                            >
                              {{ time }}</label
                            >
                          </li>
                        </ul>
                      </div>
                      <span class="time__divider">-</span>
                      <!-- To Custom Dropdown -->
                      <div class="time_dropdown">
                        <v-text-field
                          density="compact"
                          placeholder="HH:MM"
                          variant="outlined"
                          v-model="getCalenderEventById.endTime"
                          class="input_field"
                          @click="toToggleDropdown"
                          :class="{ 'is-open': toDropdownOpen }"
                        >
                          <v-icon
                            icon="mdi-clock"
                            id="menu-activator"
                            class="cursor-pointer"
                          ></v-icon>
                        </v-text-field>
                        <div
                          v-if="endTimeError"
                          class="text-red error-message tw-text-xs"
                        >
                          {{ endTimeError }}
                        </div>
                        <ul class="custom_dropdown__menu" v-if="toDropdownOpen">
                          <li
                            class="custom_dropdown__item"
                            v-for="(time, index) in filteredToTimes"
                            :key="index"
                            @click="toggleDropdownOutside"
                          >
                            <label
                              @click="getCalenderEventById.endTime = time"
                              for=""
                            >
                              {{ time }}</label
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="event_field">
                  <label>Description</label>
                  <v-textarea
                    class="input_field"
                    placeholder="Write description.."
                    v-model="getCalenderEventById.description"
                    :rules="[
                      (v) => v.length <= 255 || 'Description is too long',
                    ]"
                    variant="outlined"
                    rows="2"
                  ></v-textarea>
                </div>
                <div class="event_field">
                  <label>Owner</label>
                  <v-text-field
                    readonly
                    class="input_field"
                    placeholder="Enter location"
                    v-model="ownerEmailInEdit"
                    variant="outlined"
                  ></v-text-field>
                </div>
                <div class="event_field">
                  <label>Invite Members</label>
                  <v-autocomplete
                    v-model="getCalenderEventById.invitePeople"
                    :items="modifiedMembers"
                    class="input_field input_dropdown"
                    color="blue-grey-lighten-2"
                    item-title="email"
                    item-value="email"
                    label="Select"
                    chips
                    closable-chips
                    multiple
                    :menu-props="{ contentClass: 'invite_member_dropdown' }"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        :prepend-avatar="item.raw.avatar"
                        :text="item.raw.name"
                      ></v-chip>
                    </template>

                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props">
                        <div class="members_text">
                          <h6>
                            {{ item.raw.userName ? item.raw.userName : "Name" }}
                          </h6>
                          <p>{{ item.raw.email }}</p>
                        </div>
                        <div class="members__img">
                          <img
                            v-if="item.raw?.attachmentSource"
                            :src="item.raw?.attachmentSource"
                          />
                          <div
                            v-else
                            class="tw-rounded-full tw-overflow-hidden tw-max-h-[32px] tw-max-w-[32px] tw-min-h-[32px] tw-min-w-[32px] tw-h-[32px] tw-relative"
                          >
                            <UserProfileLogo :userName="item.raw?.userName" />
                          </div>
                        </div>
                        <v-checkbox color="indigo-darken-3"></v-checkbox
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
            <div class="modal_form_footer !tw-grid tw-grid-cols-2">
              <!-- <v-btn
                @click="openEditModal = false"
                class="button button-purple-border"
                >Cancel</v-btn
              >
              <v-btn
                class="button button-orange"
                @click="updateData(getCalenderEventById.id)"
                >Update</v-btn
              > -->
              <Button
                label="Cancel"
                variant="secondary"
                @click="openEditModal = false"
              />
              <Button
                label="Update"
                variant="accent"
                @click="updateData(getCalenderEventById.id)"
              />
            </div>
          </div>
        </div>
      </template>
    </CommonDialog>
    <!-- Create Event Modal -->
    <CommonDialog
      v-model="createEventModal"
      :isShowHeader="false"
      :isShowBackButton="false"
      :className="['update_event_modal']"
      width="441px"
      height="auto"
      ><template v-slot:body>
        <div class="modal_content">
          <div class="header">
            <h4>Create Event</h4>
            <v-btn
              variant="plain"
              icon="mdi-close"
              @click="createEventModal = false"
            ></v-btn>
          </div>
          <div class="modal_form">
            <v-form :rules="validation" ref="eventFormRef">
              <div class="form_wrapper">
                <div class="list_block__item">
                  <div class="event_field">
                    <label>Event Name</label>
                    <v-text-field
                      class="input_field"
                      placeholder="Enter event name"
                      v-model="newEvent.title"
                      :rules="validation.name"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="event_field">
                    <label>Location</label>
                    <v-text-field
                      class="input_field"
                      placeholder="Enter location"
                      :rules="validation.location"
                      v-model="newEvent.location"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="date_time_selector">
                    <div class="event_field date_selector">
                      <label>Date</label>
                      <DatePicker
                        :min-date="new Date()"
                        v-model="dataRange"
                        :popover="true"
                        :rules="validation.startDate"
                      >
                        <template #default="{ togglePopover, inputValue }">
                          <div
                            class="calendar__select"
                            @click="() => togglePopover()"
                          >
                            <v-text-field
                              :value="inputValue"
                              variant="outlined"
                              placeholder="Choose Date"
                              class="date__start input_field"
                              color="#0C0F4A"
                              ><img
                                src="../../../assets/icons/personal-calendar.svg"
                                alt=""
                              />
                            </v-text-field>
                          </div>
                        </template>
                      </DatePicker>
                    </div>
                    <!-- From Custom Dropdown -->
                    <div class="event_field time_selector">
                      <label>Choose time</label>
                      <div class="time_wrapper">
                        <div class="time_dropdown">
                          <v-text-field
                            density="compact"
                            placeholder="HH:MM"
                            variant="outlined"
                            v-model="newEvent.startTime"
                            class="input_field"
                            :rules="validation.startTime"
                            @click="fromToggleDropdown"
                            :class="{ 'is-open': fromDropdownOpen }"
                          >
                            <v-icon
                              icon="mdi-clock"
                              id="menu-activator"
                              class="cursor-pointer"
                            ></v-icon>
                          </v-text-field>
                          <div
                            v-if="startTimeError"
                            class="text-red error-message tw-text-xs"
                          >
                            {{ startTimeError }}
                          </div>
                          <ul
                            class="custom_dropdown__menu"
                            v-if="fromDropdownOpen"
                          >
                            <li
                              class="custom_dropdown__item"
                              v-for="(time, index) in filteredFromTimes"
                              :key="index"
                              @click="toggleDropdownOutside"
                            >
                              <label @click="newEvent.startTime = time" for="">
                                {{ time }}</label
                              >
                            </li>
                          </ul>
                        </div>
                        <span class="time__divider">-</span>
                        <!-- To Custom Dropdown -->
                        <div class="time_dropdown">
                          <v-text-field
                            density="compact"
                            placeholder="HH:MM"
                            variant="outlined"
                            v-model="newEvent.endTime"
                            class="input_field"
                            :rules="validation.endTime"
                            @click="toToggleDropdown"
                            :class="{ 'is-open': toDropdownOpen }"
                          >
                            <v-icon
                              icon="mdi-clock"
                              id="menu-activator"
                              class="cursor-pointer"
                            ></v-icon>
                          </v-text-field>
                          <div
                            v-if="endTimeError"
                            class="text-red error-message tw-text-xs"
                          >
                            {{ endTimeError }}
                          </div>
                          <ul
                            class="custom_dropdown__menu"
                            v-if="toDropdownOpen"
                          >
                            <li
                              class="custom_dropdown__item"
                              v-for="(time, index) in filteredToTimes"
                              :key="index"
                              @click="toggleDropdownOutside"
                            >
                              <label @click="newEvent.endTime = time" for="">
                                {{ time }}</label
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="event_field">
                    <label>Description</label>
                    <v-textarea
                      class="input_field"
                      placeholder="Write description.."
                      v-model="newEvent.description"
                      :rules="validation.description"
                      variant="outlined"
                    ></v-textarea>
                  </div>
                  <div class="event_field">
                    <label>Owner</label>
                    <v-text-field
                      readonly
                      class="input_field"
                      placeholder="Enter location"
                      v-model="eventCreateOwner"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="event_field">
                    <label>Invite Members</label>
                    <v-autocomplete
                      v-model="newEvent.member"
                      :items="modifiedMembers"
                      class="input_field input_dropdown"
                      color="blue-grey-lighten-2"
                      item-title="email"
                      item-value="email"
                      label="Select"
                      chips
                      closable-chips
                      multiple
                      :menu-props="{ contentClass: 'invite_member_dropdown' }"
                    >
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                          v-bind="props"
                          :prepend-avatar="item.raw.avatar"
                          :text="item.raw.name"
                        ></v-chip>
                      </template>

                      <template v-slot:item="{ props, item }">
                        <v-list-item v-bind="props">
                          <div class="members_text">
                            <h6>
                              {{
                                item.raw.userName ? item.raw.userName : "Name"
                              }}
                            </h6>
                            <p>{{ item.raw.email }}</p>
                          </div>
                          <div class="members__img">
                            <img
                              v-if="item.raw?.attachmentSource"
                              :src="item.raw?.attachmentSource"
                            />
                            <div
                              v-else
                              class="tw-rounded-full tw-overflow-hidden tw-max-h-[32px] tw-max-w-[32px] tw-min-h-[32px] tw-min-w-[32px] tw-h-[32px] tw-relative"
                            >
                              <UserProfileLogo :userName="item.raw?.userName" />
                            </div>
                          </div>
                          <v-checkbox
                            disabled
                            v-model="newEvent.member"
                            :value="item.raw.email"
                            color="indigo-darken-3"
                          ></v-checkbox
                        ></v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
              </div>
              <div class="modal_form_footer !tw-grid tw-grid-cols-2">
                <!-- <v-btn
                  @click="createEventModal = false"
                  class="button button-purple-border"
                  >Cancel</v-btn
                >
                <v-btn
                  class="button button-orange"
                  :disabled="!isFormValid"
                  :loading="isUploadEventData"
                  @click="submitData"
                  >Create</v-btn
                > -->

                <Button
                  label="Cancel"
                  variant="secondary"
                  @click="createEventModal = false"
                />
                <Button
                  label="Create"
                  variant="accent"
                  @click="submitData"
                  :disabled="!isFormValid"
                  :isLoading="isUploadEventData"
                />
              </div>
            </v-form>
          </div>
        </div>
      </template>
    </CommonDialog>
    <!-- Delete Modal -->
    <CommonDialog
      v-model="openDeleteModal"
      :isShowHeader="false"
      :isShowBackButton="false"
      :className="['delete_event_modal']"
      width="350px"
      height="auto"
      ><template v-slot:body>
        <div class="modal_content">
          <div class="header">
            <v-btn
              variant="plain"
              icon="mdi-close"
              @click="openDeleteModal = false"
            ></v-btn>
          </div>
          <div class="form_wrapper">
            <div class="modal_form">
              <v-btn variant="plain">
                <img src="../../../assets/icons/calendar-delete.svg" alt="" />
              </v-btn>
              <h6>Delete the event?</h6>
              <p>The event will be permanently deleted.</p>
            </div>
          </div>
          <div
            class="modal_form_footer !tw-mt-8 tw-pt-4 tw-border-t-dashed-custom !tw-justify-end"
          >
            <!-- <v-btn
              variant="plain"
              @click="openDeleteModal = false"
              class="button button-purple-border"
              >Cancel</v-btn
            >
            <v-btn
              class="button button-orange"
              @click="deletedData(getCalenderEventById?.id)"
              >Delete</v-btn
            > -->

            <Button
              label="Cancel"
              variant="secondary"
              class="!tw-w-auto"
              @click="openDeleteModal = false"
            />
            <Button
              label="Delete"
              variant="accent"
              class="!tw-w-auto"
              @click="deletedData(getCalenderEventById?.id)"
            />
          </div>
        </div>
      </template>
    </CommonDialog>
  </div>
</template>

<script setup>
import { ScheduleXCalendar } from "@schedule-x/vue";
import {
  createCalendar,
  viewDay,
  viewWeek,
  viewMonthGrid,
  viewMonthAgenda,
} from "@schedule-x/calendar";
import "@schedule-x/theme-default/dist/index.css";
import { createDragAndDropPlugin } from "@schedule-x/drag-and-drop";
import { createEventModalPlugin } from "@schedule-x/event-modal";
import { createEventsServicePlugin } from "@schedule-x/events-service";
import { createCurrentTimePlugin } from "@schedule-x/current-time";
import { ref, watch, computed, onMounted } from "vue";
import { VTimePicker } from "vuetify/labs/VTimePicker";
import { useStore } from "vuex";
import { DatePicker } from "v-calendar";
import CommonDialog from "@/core/components/CommonDialog.vue";
import { createCalendarControlsPlugin } from "@schedule-x/calendar-controls";
import { CALENDAR_STORE } from "@/store/modules/calendar";
import { USER_STORE } from "@/store/modules/user";
import { MEMBER_STORE } from "@/store/modules/manage-member";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import moment from "moment";
import { WORKSTATION } from "@/store/modules/workstation";
import { parseJSON } from "@/core/utils/common";
import { MemberInvitationStatusEnum } from "@/core/enums/RolesEnum";
import Button from "@/core/components/ui/general/Button.vue";

const openEditModal = ref(false);
const openDeleteModal = ref(false);
const createEventModal = ref(false);
const isUploadEventData = ref(false);
const eventsServicePlugin = createEventsServicePlugin();
const store = useStore();
const calendarControls = createCalendarControlsPlugin();

const selectedDate = ref();
const selectedView = ref();
const modifiedMembers = ref([]);
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const eventCreateOwner = ref("");

const calendarApp = createCalendar({
  locale: "en-GB",
  views: [viewDay, viewWeek, viewMonthGrid, viewMonthAgenda],
  plugins: [
    createDragAndDropPlugin(),
    createEventModalPlugin(),
    eventsServicePlugin,
    createCurrentTimePlugin(),
    calendarControls,
  ],
  defaultView: viewDay.name,
  calendars: {
    purple: {
      colorName: "purple",
      lightColors: {
        main: "#A338D6",
        container: "#F6EBFB",
        onContainer: "#59000d",
      },
      darkColors: {
        main: "#ffc0cc",
        onContainer: "#ffdee6",
        container: "#a24258",
      },
    },
    green: {
      colorName: "green",
      lightColors: {
        main: "#00CA72",
        container: "#E5FAF1",
        onContainer: "#004d3d",
      },
      darkColors: {
        main: "#c0fff5",
        onContainer: "#e6fff5",
        container: "#42a297",
      },
    },
    yellow: {
      colorName: "yellow",
      lightColors: {
        main: "#FFB131",
        container: "#FFF7EA",
        onContainer: "#000",
      },
      darkColors: {
        main: "#e3ae59",
        onContainer: "#c88822",
        container: "#c88822",
      },
    },
  },
  events: [],
  callbacks: {
    onEventUpdate(updatedEvent) {
      getCalenderEventById.value = {
        description: updatedEvent?.description,
        endDate: updatedEvent?.end.split(" ")[0],
        endTime: updatedEvent?.end.split(" ")[1],
        startDate: updatedEvent?.start.split(" ")[0],
        startTime: updatedEvent?.start.split(" ")[1],
        name: updatedEvent?.title,
      };
      updateData(updatedEvent?.id);
    },
    onRangeUpdate(range) {
      const startDate = range.start.split(" ")[0];
      const endDate = range.end.split(" ")[0];
      dataRange.value = new Date(startDate);
      const startMonth = new Date(range.start).getMonth() + 1;
      const endMonth = new Date(range.end).getMonth() + 1;
      if (startDate == endDate) {
        const dayViewDate = formatDate(startDate, "fullDate");
        selectedDate.value = dayViewDate;
      } else if (
        formatDate(startDate, "date") !== formatDate(endDate, "date") &&
        startMonth == endMonth
      ) {
        const weekViewDate = formatDateRange(startDate, endDate);
        selectedDate.value = weekViewDate;
      } else {
        const monthViewDate = formatDate(startDate, "month");
        selectedDate.value = monthViewDate;
      }
      getPersonalCalendarEvent(startDate, endDate);
    },
  },
});

// const handleCalenderView = (viewName) => {
//   calendarControls.setView(viewName);
//   selectedView.value = calendarControls.getView();
// };

const handleCalenderView = (viewName) => {
  const todayDate = new Date();
  const startOfMonth = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    1
  );
  const endOfMonth = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth() + 1,
    0
  );
  const startOfWeek = new Date(todayDate);
  startOfWeek.setDate(todayDate.getDate() - todayDate.getDay());
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  if (viewName === "month-grid") {
    getPersonalCalendarEvent(
      startOfMonth.toISOString(),
      endOfMonth.toISOString()
    );
  }
  if (viewName === "week") {
    getPersonalCalendarEvent(
      startOfWeek.toISOString(),
      endOfWeek.toISOString()
    );
  }
  calendarControls.setView(viewName);
  selectedView.value = calendarControls.getView();
};

const formatDateRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const formatDate = (date) => {
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const formattedDay = day;
    const formattedMonth = months[month - 1];
    const formattedYear = year;

    return `${formattedDay} ${formattedMonth}`;
  };

  const formattedStart = formatDate(start);
  const formattedEnd = formatDate(end);
  const year = start.getUTCFullYear();

  return `${formattedStart} - ${formattedEnd} ${year}`;
};

const formatDate = (dateString, format) => {
  const date = new Date(dateString);

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthsOfYear = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  switch (format) {
    case "fullDayDate": {
      const day = date.getUTCDate();
      const month = date.getUTCMonth();
      const year = date.getUTCFullYear();
      const dayOfWeek = date.getUTCDay();
      return `${day} ${monthsOfYear[month]} ${year}, ${daysOfWeek[dayOfWeek]}`;
    }
    case "fullDate": {
      const day = date.getUTCDate();
      const month = date.getUTCMonth();
      const year = date.getUTCFullYear();
      return `${day} ${monthsOfYear[month]}, ${year}`;
    }
    case "date": {
      const day = date.getUTCDate();
      const month = date.getUTCMonth() + 1;
      const year = date.getUTCFullYear();
      const formattedDay = day < 10 ? "0" + day : day;
      const formattedMonth = month < 10 ? "0" + month : month;
      return `${formattedDay}/${formattedMonth}/${year}`;
    }
    case "yyyy-mm-dd": {
      const day = date.getUTCDate();
      const month = date.getUTCMonth() + 1;
      const year = date.getUTCFullYear();
      const formattedDay = day < 10 ? "0" + day : day;
      const formattedMonth = month < 10 ? "0" + month : month;
      return `${year}-${formattedMonth}-${formattedDay}`;
    }
    case "yyyy-mm-dd+1": {
      const day = date.getUTCDate() + 1;
      const month = date.getUTCMonth() + 1;
      const year = date.getUTCFullYear();
      const formattedDay = day < 10 ? "0" + day : day;
      const formattedMonth = month < 10 ? "0" + month : month;
      return `${year}-${formattedMonth}-${formattedDay}`;
    }
    case "month": {
      const month = date.getUTCMonth();
      const year = date.getUTCFullYear();
      return `${monthsOfYear[month]}, ${year}`;
    }
    case "month-date": {
      const day = date.getUTCDate();
      const month = date.getUTCMonth();
      const nextDay = day + 1;
      const monthName = monthsOfYear[month];
      return `${monthName} ${day} - ${monthName} ${nextDay}`;
    }
    default: {
      throw new Error("Invalid format type");
    }
  }
};

const getCalenderEventById = ref({});
const newEvent = ref({
  title: "",
  description: "",
  startDate: null,
  startTime: null,
  endDate: null,
  endTime: null,
  member: [],
});

const eventFormRef = ref(null);

const isFormValid = computed(() => {
  return (
    newEvent.value.title &&
    newEvent.value.title.length <= 255 &&
    newEvent.value.location?.length <= 255 &&
    newEvent.value.description?.length <= 255 &&
    dataRange.value
  );
});

const dummyData = ref({
  startDate: new Date(),
  startTime: "",
  endDate: new Date(),
  endTime: "",
});

const fetchModalData = (id) => {
  getCalenderEventById.value = personalCalendarList.value.find(
    (event) => event.id === id
  );
  getCalenderEventById.value.invitePeople =
    typeof getCalenderEventById.value.invitePeople === "string"
      ? parseJSON(getCalenderEventById.value.invitePeople)
      : getCalenderEventById.value.invitePeople;
  openEditModal.value = true;
};

createCurrentTimePlugin({
  // Whether the indicator should be displayed in the full width of the week. Defaults to false
  fullWeekWidth: true,
});

const convertDateFormate = (inputDate) => {
  // Extracting date components
  const dateComponents = inputDate.split(" ");
  const monthMap = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };
  const month = monthMap[dateComponents[1]];
  const day = dateComponents[2];
  const year = dateComponents[3];
  const time = dateComponents[4].slice(0, -3);
  const hours = time.split(":")[0];
  const minutes = time.split(":")[1];
  const outputDate = `${year}-${month}-${day} ${hours}:${minutes}`;
  return outputDate;
};

const resetCreateEventModal = () => {
  newEvent.value.id = "";
  newEvent.value.title = "";
  newEvent.value.start = "";
  newEvent.value.end = "";
  newEvent.value.description = "";
  newEvent.value.member = "";
  dummyData.value.startDate = new Date("2024-02-05");
  dummyData.value.startTime = "";
  dummyData.value.endDate = new Date("2024-02-05");
  dummyData.value.endTime = "";
};

watch(
  () => store.state.events,
  (newEvents) => {
    if (!store.state.deleteEvent) {
      calendarApp.events.set(newEvents);
    } else {
      store.commit("setDeleteEventAction", false);
    }
  },
  { deep: true }
);
const dataRange = ref(new Date());
const submitData = async () => {
  const isFormValid = await eventFormRef.value.validate();
  console.log("isFormValid :>> ", isFormValid);
  if (!isFormValid.valid) return;
  try {
    isUploadEventData.value = true;
    newEvent.value?.member.push(user.value?.email);
    await store.dispatch(`${CALENDAR_STORE}/createPersonalEvent`, {
      name: newEvent.value?.title,
      description: newEvent.value?.description,
      location: newEvent.value?.location,
      startDate: formatDate(dataRange.value, "yyyy-mm-dd"),
      endDate: formatDate(dataRange.value, "yyyy-mm-dd"),
      startTime: newEvent.value?.startTime,
      endTime: newEvent.value?.endTime,
      userId: user.value?.id,
      invitePeople: JSON.stringify(newEvent.value?.member),
    });
    calendarControls.setDate(moment(dataRange.value).format("YYYY-MM-DD"));
    await getPersonalCalendarEvent(
      formatDate(dataRange.value, "yyyy-mm-dd"),
      formatDate(dataRange.value, "yyyy-mm-dd")
    );
    resetProjectCalendarData();
  } catch (err) {
    console.log();
  } finally {
    isUploadEventData.value = false;
    createEventModal.value = false;
    fromDropdownOpen.value = false;
    toDropdownOpen.value = false;
  }
};

const updateData = async (id) => {
  const index = personalCalendarList.value.find((event) => event.id === id);
  const updateEvents = {
    id: index?.id,
    title: index?.name,
    start: `${
      dataRange.value
        ? formatDate(dataRange.value, "yyyy-mm-dd")
        : index?.startDate
    } ${index?.startTime}`,
    end: `${
      dataRange.value
        ? formatDate(dataRange.value, "yyyy-mm-dd")
        : index?.startDate
    } ${index?.endTime}`,
    description: index?.description,
  };

  await store.dispatch(`${CALENDAR_STORE}/updateCalendarEvent`, {
    TraderCalenderId: index?.id,
    updateData: {
      name: getCalenderEventById.value?.name
        ? getCalenderEventById.value?.name
        : index?.name,
      description: getCalenderEventById.value?.description
        ? getCalenderEventById.value?.description
        : index?.description,
      location: index?.location,
      startDate: formatDate(index?.startDate, "yyyy-mm-dd"),
      endDate: formatDate(index?.startDate, "yyyy-mm-dd"),
      startTime: getCalenderEventById.value?.startTime
        ? getCalenderEventById.value?.startTime
        : index?.startTime,
      endTime: getCalenderEventById.value?.endTime
        ? getCalenderEventById.value?.endTime
        : index?.endTime,
      invitePeople: JSON.stringify(
        getCalenderEventById.value?.invitePeople
          ? getCalenderEventById.value?.invitePeople
          : index?.invitePeople
      ),
    },
  });
  eventsServicePlugin.update(updateEvents);
  calendarControls.setDate(moment(index?.startDate).format("YYYY-MM-DD"));
  await getPersonalCalendarEvent(
    formatDate(getCalenderEventById.value.startDate, "yyyy-mm-dd"),
    formatDate(getCalenderEventById.value.startDate, "yyyy-mm-dd")
  );
  resetProjectCalendarData();
  openEditModal.value = false;
  getCalenderEventById.value = {};
};

const deleteEvent = (id) => {
  openDeleteModal.value = true;
  getCalenderEventById.value = personalCalendarList.value.find(
    (event) => event.id === id
  );
};

const deletedData = async (id) => {
  personalCalendarList.value = await store.dispatch(
    `${CALENDAR_STORE}/deleteCalendarEvent`,
    {
      TraderCalenderId: id,
    }
  );
  openDeleteModal.value = false;
  eventsServicePlugin.remove(getCalenderEventById.value?.id);
  await getPersonalCalendarEvent(
    getCalenderEventById.value?.startDate,
    getCalenderEventById.value?.endDate
  );
  resetProjectCalendarData();
};

const personalCalendarList = ref();

const getPersonalCalendarEvent = async (startDate, endDate) => {
  const todayDate = new Date();
  let params = {
    userId: user.value?.id,
    startDate: startDate
      ? formatDate(startDate, "yyyy-mm-dd")
      : formatDate(todayDate, "yyyy-mm-dd"),
    endDate: endDate
      ? formatDate(endDate, "yyyy-mm-dd")
      : formatDate(todayDate, "yyyy-mm-dd"),
  };
  params = Object.fromEntries(
    Object.entries(params).filter((value) => (value[1] === 0 ? true : value[1]))
  );

  personalCalendarList.value = await store.dispatch(
    `${CALENDAR_STORE}/getPersonalCalendarEvent`,
    {
      params: params,
    }
  );

  if (personalCalendarList.value?.length) {
    const colors = ["purple", "yellow", "green"];

    const events = personalCalendarList.value.map((event, index) => ({
      id: event.id,
      title: event.name,
      start: `${event.startDate} ${convertTo24Hour(event.startTime)}`,
      end: `${event.endDate} ${convertTo24Hour(event.endTime)}`,
      description: event.description,
      calendarId: colors[index % colors.length],
    }));
    // for (  let i = 0; i < personalCalendarList.value?.length; i++) {
    // eventsServicePlugin.remove(personalCalendarList.value[i].id);
    calendarApp.events.set([]);
    // }
    if (events) {
      // events.forEach((event) => eventsServicePlugin.add(event));
      calendarApp.events.set(events);
    }
  }
};
function convertTo24Hour(time) {
  const [timePart, modifier] = time.split(" ");
  let [hours, minutes] = timePart.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}`;
}
const onClickCreateEventModal = () => {
  createEventModal.value = true;
  newEvent.value.title = "";
  newEvent.value.description = "";
  newEvent.value.startTime = null;
  newEvent.value.endTime = null;
  newEvent.value.member = [];
  newEvent.value.location = "";
  // dataRange.value = new Date();
};

const fromTime = ref(null);
const toTime = ref(null);
const times = ref([]);

const populateTimes = () => {
  times.value = [];
  const currentTime = moment();

  const date = new Date("12/12/2000 12:00:00 AM");

  for (let i = 0; i < 24; i++) {
    for (let j = 0; j < 60; j = j + 15) {
      date.setHours(i);
      date.setMinutes(j);

      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const timeMoment = moment(formattedTime, "hh:mm A");
      if (currentTime.isSame(moment(dataRange.value), "day")) {
        if (timeMoment.isAfter(currentTime)) {
          times.value.push(formattedTime);
        }
      } else {
        times.value.push(formattedTime);
      }
    }
  }
  times.value.push("11:59 PM");
  filteredFromTimes.value = [...times.value];
  filteredToTimes.value = [...times.value];
};

const updateToTime = () => {
  if (
    newEvent.value.endTime &&
    times.value.indexOf(newEvent.value.endTime) <=
      times.value.indexOf(newEvent.value.startTime)
  ) {
    newEvent.value.endTime = null;
  }
};

const isDateAfterCurrentDate = (givenDate) => {
  const today = moment().startOf("day");
  const givenMoment = moment(givenDate, "YYYY-MM-DD");
  return givenMoment.isSameOrAfter(today);
};

const isTimeAfterCurrentTime = (givenTime) => {
  const now = moment();
  if (now.isSame(moment(newEvent.value.startDate), "day")) {
    const givenMoment = moment(givenTime, "hh:mm A");
    return givenMoment.isAfter(now);
  } else {
    return true;
  }
};

const validateEndTime = (endTime) => {
  const start = moment(newEvent.value.startTime, "hh:mm A");
  const end = moment(endTime, "hh:mm A");
  return end.isAfter(start) && start.isSame(end, "day");
};

const validation = ref({
  name: [
    (v) => !!v || "Name is required",
    (v) => v.length <= 255 || "Name is too long",
  ],
  location: [
    // (v) => !!v || "Location is required.",
    (v) => v.length <= 50 || "Location is too long",
  ],
  startDate: [
    (v) => !!v || "Start date is required.",
    (v) =>
      isDateAfterCurrentDate(v) ||
      "Date must be  greater than or equal to today's date",
  ],
  startTime: [
    (v) => !!v || "Start time is required.",
    (v) => timeRegex.test(v) || "Invalid time format. Please use HH:MM am/pm.",
    (v) =>
      isTimeAfterCurrentTime(v) || "Time must Be greater than current time.",
  ],
  endTime: [
    (v) => !!v || "End time is required.",
    (v) => timeRegex.test(v) || "Invalid time format. Please use HH:MM am/pm.",
    (v) => validateEndTime(v) || "Time must be less than start time.",
  ],
  description: [
    // (v) => !!v || "Description is required.",
    (v) => v.length <= 255 || "Description is too long",
  ],
});

const isDisabled = (time, fromTimeValue) => {
  if (!fromTimeValue) return false;
  return times.value.indexOf(time) <= times.value.indexOf(fromTimeValue);
};

// populateTimes();

const getWorkstationProfile = async (profileImage) => {
  if (!profileImage) {
    return null;
  }
  try {
    const imagePath = profileImage;
    const response = await store.dispatch(`${USER_STORE}/getImage`, imagePath);
    if (response) {
      return response;
    }
    return null;
  } catch (error) {
    return null;
  }
};

const ownerEmailInEdit = computed(() => {
  if (getCalenderEventById.value?.userId?.email) {
    return getCalenderEventById.value?.userId?.email;
  }
  return "";
});

const modifyMembersList = async () => {
  if (!teamMemberList.value && !teamMemberList.value.length) {
    return;
  }
  try {
    const defaultMember = teamMemberList.value[0];
    const { profileImage } = defaultMember?.userWorkstation;

    const source = await getWorkstationProfile(profileImage);

    teamMemberList.value.forEach((member, index) => {
      if (
        member?.invitationStatus === MemberInvitationStatusEnum.ACCEPTED &&
        member?.toUser?.id !== user.value?.id
      ) {
        if (index === 0) {
          modifiedMembers.value.push({
            ...member,
            attachmentSource: source,
          });
        } else {
          modifiedMembers.value.push({
            ...member,
          });
        }
      }
    });
  } catch (error) {
    console.log();
  }
};

const teamMemberList = ref([]);

const getTeamMember = async () => {
  try {
    const response = await store.dispatch(`${MEMBER_STORE}/getTeamMember`, {
      userId: user.value?.id,
    });

    teamMemberList.value = response;
  } catch (err) {
    console.log();
  }
};

// Convert time to Date object
const timeToDate = (time) => {
  const [hourMinute, period] = time.split(" ");
  let [hour, minute] = hourMinute.split(":");
  hour = parseInt(hour);
  minute = parseInt(minute);
  if (period.toLowerCase() === "pm" && hour !== 12) hour += 12;
  if (period.toLowerCase() === "am" && hour === 12) hour = 0;
  return new Date(2000, 0, 1, hour, minute);
};

const fromDropdownOpen = ref(false);
const toDropdownOpen = ref(false);
const filteredFromTimes = ref([...times.value]);
const filteredToTimes = ref([...times.value]);
const startTimeError = ref("");
const endTimeError = ref("");

// Toggle the from time dropdown
const fromToggleDropdown = () => {
  newEvent.value.startTime = null;
  newEvent.value.endTime = null;
  fromDropdownOpen.value = !fromDropdownOpen.value;
};

// Toggle the to time dropdown
const toToggleDropdown = () => {
  newEvent.value.endTime = null;
  if (
    newEvent.value.startTime != null ||
    getCalenderEventById.value.startTime != null
  ) {
    toDropdownOpen.value = !toDropdownOpen.value;
  }
};

// Close the both time dropdowns (start and end)
const toggleDropdownOutside = () => {
  console.log(fromDropdownOpen.value, toDropdownOpen.value);
  if (fromDropdownOpen.value) {
    fromDropdownOpen.value = false;
  }
  if (toDropdownOpen.value) {
    toDropdownOpen.value = false;
  }
};

// Close the dropdowns and create event modal
const closeCreateEventModal = () => {
  createEventModal.value = false;
  fromDropdownOpen.value = false;
  toDropdownOpen.value = false;
};

// Regex for validating 12-hour time format
const timeRegex = /^(0[1-9]|1[0-2]):[0-5][0-9] (am|pm)$/i;

// Common callback function for watching times
const watchTimesCallback = (newValue) => {
  const currentTime = moment();
  const timeToDate = (time) => {
    return moment(time, "HH:mm A");
  };
  fromDropdownOpen.value = false;
  toDropdownOpen.value = false;
  // Validate and filter startTime
  if (newValue.startTime && typeof newValue.startTime === "string") {
    const startTimeMoment = timeToDate(newValue.startTime);

    if (!timeRegex.test(newValue.startTime)) {
      startTimeError.value = "Invalid time format. Please use HH:MM am/pm";
    } else if (
      currentTime.isSame(moment(dataRange.value), "day") &&
      startTimeMoment.isSameOrBefore(currentTime)
    ) {
      startTimeError.value = "Start time must be greater than current time.";
    } else {
      startTimeError.value = "";
      filteredFromTimes.value = times.value.filter((time) =>
        time.toLowerCase().includes(newValue.startTime.toLowerCase())
      );
    }
  } else {
    startTimeError.value = "";
    filteredFromTimes.value = [...times.value];
  }

  // Validate and filter endTime
  if (newValue.endTime && typeof newValue.endTime === "string") {
    const endTimeMoment = timeToDate(newValue.endTime);

    if (!timeRegex.test(newValue.endTime)) {
      endTimeError.value = "Invalid time format. Please use HH:MM am/pm";
    } else if (
      newValue.startTime &&
      typeof newValue.startTime === "string" &&
      timeRegex.test(newValue.startTime)
    ) {
      const startTimeMoment = timeToDate(newValue.startTime);

      if (endTimeMoment.isSameOrBefore(startTimeMoment)) {
        endTimeError.value = "End time must be later than start time";
      } else {
        endTimeError.value = "";
        filteredToTimes.value = times.value.filter((time) =>
          time.toLowerCase().includes(newValue.endTime.toLowerCase())
        );
      }
    } else {
      endTimeError.value = "";
      filteredToTimes.value = times.value.filter((time) =>
        time.toLowerCase().includes(newValue.endTime.toLowerCase())
      );
    }
  } else {
    endTimeError.value = "";
    filteredToTimes.value = [...times.value];
  }
};

// Watch both newEvent and getCalenderEventById
watch(newEvent, watchTimesCallback, { deep: true });
watch(getCalenderEventById, watchTimesCallback, { deep: true });
watch(
  () => dataRange.value,
  (newVal) => {
    populateTimes();
  },
  { immediate: true }
);
const resetProjectCalendarData = () => {
  store.dispatch(`${CALENDAR_STORE}/setProjectCalendarData`, {
    calendarData: {
      calendarData: [],
      calendarSideList: [],
    },
    type: "team",
  });

  store.dispatch(`${CALENDAR_STORE}/setProjectCalendarData`, {
    calendarData: {
      calendarData: [],
      calendarSideList: [],
    },
    type: "project",
  });
};

onMounted(async () => {
  selectedView.value = "day";
  const date = new Date();
  selectedDate.value = formatDate(date, "fullDate");
  await getPersonalCalendarEvent();
  await getTeamMember();
  await modifyMembersList();
  eventCreateOwner.value = user.value?.email;
});
</script>

<style lang="scss">
@import "@/modules/calendar/styles/PersonalCalendarComponent.scss";

.custom-outer-grid {
  height: 4.16667%;
  width: auto !important;

  .custom-inner-grid {
    position: relative;
    height: 100%;
    top: 13.5417%;
    left: 0%;
    background-color: #fff7ea;
    color: #000;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-left: 4px solid #ffa71a;
    width: auto;
    padding: 4px;
    position: absolute;
    border-radius: 4px;
    font-size: 0.75rem;

    .custom-event-title {
      font-weight: 600;
      top: 13.5417%;
      height: 9.375%;
      left: 0%;
      width: 100%;
      background-color: #fff7ea;
      color: #000;
      border-top: 0px;
      border-right: 0px;
      border-bottom: 0px;
    }

    .custom-event-time {
      display: flex;
      align-items: center;
      white-space: nowrap;
      margin-top: 0.75rem;
    }
  }
}
.custom-modal {
  padding: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
}
.date-selector {
  position: absolute;
  left: 50px;
  top: -11px;
  pointer-events: none;
}
</style>
